import GiftIcon from '../../assets/icons/promotion/GiftIcon';
import useInitialData from '../../hooks/global/useInitialData';
import useTheme from '../../hooks/ui/useTheme';

const Offer = (): JSX.Element | null => {
  const { data } = useInitialData();
  const { company } = data;
  const theme = useTheme();

  if (!company?.offer_title && !company?.offer_description) return null;

  return (
    <div className="border border-brand-primary rounded-lg p-md bg-brand-card space-y-sm">
      <div className="flex justify-between items-center gap-sm w-full">
        {company?.offer_title && <h6 className="text-sm text-brand-primary">{company?.offer_title}</h6>}
        <div className="shrink-0">
          <GiftIcon className="w-9 h-9" color={theme.color.brand.primary} />
        </div>
      </div>
      {company?.offer_description && <p className="text-sm whitespace-pre-line">{company?.offer_description}</p>}
    </div>
  );
};

export default Offer;
